import React, { useState } from "react";
import "../Style/Footer.css";
import { ReactComponent as FacebookIcon } from "../icons/FacebookIcon.svg";
import { ReactComponent as InstagramIcon } from "../icons/InstagramIcon.svg";
import { ReactComponent as PinterestIcon } from "../icons/PinterestIcon.svg";
import { ReactComponent as YoutubeIcon } from "../icons/YoutubeIcon.svg";
import Logo from "../icons/Logo";
import HandMadeInTexas from "../icons/HandMadeInTexas.js";
import { api } from "../api/client.js";
import { useSiteSettings } from "../context/SiteSettingsContext.js";
import { getRequestErrorMessage } from "../Utils/formValidation.js";
import { FaInstagram, FaFacebook, FaTiktok } from "react-icons/fa";
import TermsAndConditions from "./TermsAndConditions.js";

const QUICK_LINKS = [
  { label: "Home", href: "/" },
  // { label: "Experiences", href: "/#journey" },
  { label: "Collections", href: "/contact-us" },
  { label: "Reserve", href: "/reserve-occaission" },
  // { label: "Contact", href: "/contact-us" },
];
const ABOUT_LINKS = [
  // { label: "Our Story", href: "/our-story" },
  { label: "Our Story", href: "/our-story" },
  // { label: "Contact", href: "/contact-us" },
];
const CARE_LINKS = ["Terms & Conditions"];

function Footer() {
  const { settings } = useSiteSettings();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [termsOpen, setTermsOpen] = useState(false);
  const socialLinks = [
    {
      name: "Facebook",
      url: settings.socialLinks.facebook,
      Icon: FacebookIcon,
    },
    {
      name: "Instagram",
      url: settings.socialLinks.instagram,
      Icon: InstagramIcon,
    },
    {
      name: "Pinterest",
      url: settings.socialLinks.pinterest,
      Icon: PinterestIcon,
    },
    {
      name: "YouTube",
      url: settings.socialLinks.youtube,
      Icon: YoutubeIcon,
    },
  ].filter((social) => social.url);

  const handleSubscribe = async (event) => {
    event.preventDefault();
    if (submitting) return;

    const normalizedEmail = email.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail)) {
      setError("Enter a valid email address.");
      setMessage("");
      return;
    }

    setSubmitting(true);
    setError("");
    setMessage("");
    try {
      await api.newsletterSubscriptions.create({ email: normalizedEmail });
      setEmail("");
      setMessage("Thank you for joining our journey.");
    } catch (requestError) {
      setError(
        getRequestErrorMessage(
          requestError,
          "We could not subscribe you right now. Please try again.",
        ),
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-brand">
          <div className="footer-logo">
            <span className="footer-logo-svg">
              <Logo />
            </span>
            <span className="footer-logo-name">Up &amp; Away</span>
          </div>
          <p className="footer-tagline">
            Handcrafted to elevate spaces. Created to uplift the people within
            them.
          </p>
          <span className="footer-made-mark" aria-hidden="true">
            <HandMadeInTexas />
          </span>
          {/* <div className="footer-socials">
            {socialLinks.map(({ name, url, Icon }) => (
              <a
                className="footer-social-btn"
                aria-label={name}
                href={url}
                target="_blank"
                rel="noreferrer"
                key={name}
              >
                <Icon />
              </a>
            ))}
          </div> */}
        </div>

        <div className="footer-col">
          <p className="footer-col-title">Quick Links</p>
          <div className="footer-col-links">
            {QUICK_LINKS.map((link) => (
              <a href={link.href} className="footer-col-link" key={link.label}>
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="footer-col">
          <p className="footer-col-title">About</p>
          <div className="footer-col-links">
            {ABOUT_LINKS.map((link) => (
              <a href={link.href} className="footer-col-link" key={link.label}>
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="footer-col">
          <p className="footer-col-title">Customer Care</p>
          <div className="footer-col-links">
            {CARE_LINKS.map((link) => (
              <button
                type="button"
                className="footer-col-link footer-col-button"
                onClick={() => setTermsOpen(true)}
                key={link}
              >
                {link}
              </button>
            ))}
          </div>
        </div>

        <div className="footer-join">
          <p className="footer-join-title">Join Our Journey</p>
          <p className="footer-join-desc">
            Explore our work, creative stories, and the celebrations we bring to
            life.
          </p>
          <div className="footer-socials">
            {socialLinks.map(({ name, url, Icon }) => (
              <a
                className="footer-social-btn"
                aria-label={name}
                href={url}
                target="_blank"
                rel="noreferrer"
                key={name}
              >
                <Icon />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">
          &copy; 2025 UP &amp; AWAY. All rights reserved.
        </p>
      </div>
      <TermsAndConditions
        isOpen={termsOpen}
        onClose={() => setTermsOpen(false)}
      />
    </footer>
  );
}

export default Footer;
